<template>
  <router-view />
</template>

<script setup></script>

<style lang="scss">
// ============================================================
// Global Element Plus skin — "Cozy Cartoon 暖阳卡通"
// 大圆角、圆胖字体、柔和暖色投影，休闲治愈感。
// ElMessageBox 定义在 styles/theme.scss，保持单一来源。
// ============================================================

#app {
  width: 100%;
  height: 100%;

  .el-backtop {
    width: 48px;
    height: 48px;
    background: $carbon;
    border: 1px solid $rule-mid;
    border-radius: $r-pill;
    box-shadow: $shadow-md;
    transition: all $dur-fast $ease-bounce;

    .el-icon {
      color: $accent;
    }

    &:hover {
      background: $grad-accent;
      border-color: transparent;
      transform: translateY(-3px) scale(1.05);

      .el-icon {
        color: $text-on-orange;
      }
    }
  }
}

// ---------------------------------------------------------
// Dialog overlay
// ---------------------------------------------------------
.el-overlay:has(.carrom-dialog),
.el-overlay-dialog:has(.carrom-dialog) {
  background-color: rgba($scrim, 0.45) !important;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

// ---------------------------------------------------------
// Shared dialog shell (login / pay)
// ---------------------------------------------------------
.el-dialog.carrom-dialog {
  background: $carbon !important;
  border: 1px solid $rule-mid !important;
  border-radius: $r-xl !important;
  padding: 0 !important;
  overflow: hidden;
  box-shadow: $shadow-lg;

  .el-dialog__header {
    margin: 0;
    padding: 24px 28px 18px;
    border-bottom: 1px dashed $rule-mid;
    background: linear-gradient(180deg, $dark-50 0%, $carbon 100%);
  }

  .el-dialog__title {
    font-family: $font-display;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: none;
    color: $text-strong;
  }

  .el-dialog__headerbtn {
    top: 18px;
    right: 18px;
    width: 32px;
    height: 32px;
    background: rgba(255, 138, 61, 0.08);
    border: 1px solid $rule;
    border-radius: $r-pill;
    transition: all $dur-fast $ease-out;

    .el-dialog__close {
      color: $text-muted;
      font-size: 15px;
    }

    &:hover {
      background: $grad-accent;
      border-color: transparent;

      .el-dialog__close {
        color: $text-on-orange;
      }
    }
  }

  .el-dialog__body {
    padding: 28px;
    color: $text-body;
  }

  // ---- Form controls ----
  .el-input__wrapper,
  .el-select__wrapper,
  .el-textarea__inner {
    background: $dark-900 !important;
    box-shadow: none !important;
    border: 1px solid $rule-mid !important;
    border-radius: $r-md !important;
    padding: 10px 16px;
    transition: border-color $dur-fast $ease-out;

    &:hover {
      border-color: $accent-light !important;
    }

    &.is-focus,
    &:focus-within {
      border-color: $accent !important;
      box-shadow: 0 0 0 3px rgba(255, 138, 61, 0.18) !important;
    }
  }

  .el-input__inner,
  .el-textarea__inner,
  .el-select__placeholder {
    color: $text-strong !important;
    font-family: $font-body;

    &::placeholder {
      color: $text-light !important;
    }
  }

  .el-form-item__label {
    color: $text-muted !important;
    font-family: $font-body;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.01em;
    text-transform: none;
  }

  .el-form-item__error {
    font-family: $font-body;
    font-size: 12px;
    letter-spacing: 0.02em;
    color: $danger !important;
  }
}

// ---------------------------------------------------------
// Select dropdown (rendered in a popper, outside the dialog)
// ---------------------------------------------------------
.el-select-dropdown {
  background: $carbon !important;
  border: 1px solid $rule-mid !important;
  border-radius: $r-md !important;
  box-shadow: $shadow-lg !important;

  .el-select-dropdown__item {
    font-family: $font-body;
    font-size: 14px;
    color: $text-body;
    border-radius: $r-sm;

    &.is-hovering,
    &:hover {
      background: rgba(255, 138, 61, 0.08) !important;
      color: $text-strong !important;
    }

    &.is-selected {
      color: $accent-dark !important;
      font-weight: 700;
    }
  }

  .el-popper__arrow::before {
    background: $carbon !important;
    border-color: $rule-mid !important;
  }
}

// ---------------------------------------------------------
// Toast messages
// ---------------------------------------------------------
.el-message {
  background: $carbon !important;
  border: 1px solid $rule-mid !important;
  border-left: 4px solid $accent !important;
  border-radius: $r-md !important;
  box-shadow: $shadow-lg !important;

  .el-message__content {
    font-family: $font-body !important;
    font-size: 14px !important;
    letter-spacing: 0.01em;
    color: $text-strong !important;
  }

  &.el-message--error {
    border-left-color: $danger !important;
  }

  &.el-message--success {
    border-left-color: $success !important;
  }

  &.el-message--warning {
    border-left-color: $warning !important;
  }
}
</style>
